import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';

import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { BlogCategoryComponent } from './blog-category.component';



const routes: Routes = [
    {
        path: 'blog-category',
        component: BlogCategoryComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RichTextEditorAllModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        BlogCategoryComponent
    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class BlogCategoryModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog-category/blog-category.module.ts